<template>
  <div class="table-scroller">
    <table class="communities-table">
      <thead>
        <tr style="background: #27aae1; color: white">
          <th>Activities</th>
          <th>Brief description</th>
          <th>Related Groups and Projects</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="extra-header-row" colspan="3">
            <p id="activity_1" class="text-center ma-0 pa-0">
              CHANGE - focusing on priorities, policies and incentives for
              implementing FAIR
            </p>
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            <span id="activity_2" class="activity">
              <b
                >1. Classify and align research data policies across publishers
                and funders</b
              >
            </span>
          </td>
          <td>
            FAIRsharing works within the
            <a href="https://www.rd-alliance.org/" target="_blank">RDA</a>
            community to align data policies via the use of standardized
            templates, which will be implemented in the FAIRsharing registry of
            policies.
          </td>
          <td>
            <a
              href="https://www.rd-alliance.org/groups/data-policy-standardisation-and-implementation-ig"
              target="_blank"
              >RDA Policy IG</a
            >,
            <a
              href="https://www.rd-alliance.org/groups/research-funders-and-stakeholders-open-research-and-data-management-policies-and-practices-ig"
              target="_blank"
              >RDA Funders IG,</a
            >
            and
            <a
              href="https://www.rd-alliance.org/group/biosharing-registry-connecting-data-policies-standards-databases-life-sciences.html"
              target="_blank"
              >RDA FAIRsharing WG</a
            >
          </td>
        </tr>
        <tr>
          <td>
            FAIRsharing works with the
            <a href="https://cos.io/" target="_blank"
              >Center for Open Science (COS)</a
            >
            to use TOP to standardize the classification of data policies in the
            FAIRsharing registry of policies.
          </td>
          <td>
            <a href="https://osf.io/zaumk/" target="_blank"
              ><b>Agreement</b> between FAIRsharing and COS.</a
            >
          </td>
        </tr>
        <tr>
          <td>
            <span id="activity_3" class="activity">
              <b>2. Moderate cross-publishers discussion on repositories</b>
            </span>
          </td>
          <td>
            Through a collaboration with
            <a
              href="https://blog.datacite.org/data-repository-selection-which-criteria-matter/"
              target="_blank"
              >Datacite</a
            >, FAIRsharing moderated a discussion among a number of journal
            publishers reduce the inconsistency provided in publisher's advice
            to researchers and increase repository use, which remains far from
            optimal:
            <a href="https://doi.org/10.5281/zenodo.4683794">final report.</a>
          </td>
          <td>
            <a href="https://doi.org/10.5438/z32p-wj46" target="_blank"
              ><b>Agreement</b> between FAIRsharing and Datacite;
            </a>
            <a
              href="https://www.rd-alliance.org/group/biosharing-registry-connecting-data-policies-standards-databases-life-sciences.html"
              target="_blank"
              >RDA FAIRsharing WG;
            </a>
            <a
              href="https://blogs.plos.org/plos/2019/11/request-for-comments-on-data-repository-selection-criteria-that-matter/"
              target="_blank"
            >
              PLOS,
            </a>
            <a
              href="https://researchdata.springernature.com/users/69696-varsha-khodiyar/posts/57690-data-repository-selection-request-for-comments"
            >
              Springer Nature,
            </a>
            <a
              href="https://about.hindawi.com/blog/data-repository-selection-criteria-that-matter-request-for-comments/"
              target="_blank"
              >Hindawi,
            </a>
            <a
              href="https://blog.f1000.com/2019/11/29/data-repository-selection-criteria-that-matter-request-for-comments/"
              target="_blank"
              >F1000 Research,
            </a>
            <a
              href="https://www.wiley.com/network/researchers/latest-content/data-repository-selection-criteria-that-matter-we-want-to-hear-from-you"
              target="_blank"
              >Wiley,
            </a>
            <a
              href="https://librarianresources.taylorandfrancis.com/data-repository-selection-criteria-that-matter/"
              target="_blank"
              >Taylor and Francis,
            </a>
            <a
              href="https://www.elsevier.com/connect/share-your-thoughts-to-make-data-sharing-simpler-and-more-efficient"
              target="_blank"
              >Elsevier,
            </a>
            <a
              href="https://elifesciences.org/inside-elife/7b9ba7ef/elife-latest-criteria-for-data-repository-selection"
              target="_blank"
              >eLife,
            </a>
            <a
              href="http://gigasciencejournal.com/blog/fairsharing-data-repository-selection/"
              target="_blank"
              >GigaScience;
            </a>
            <a
              href="https://www.cambridge.org/core/blog/2019/12/10/openresearch-selecting-a-data-repository-criteria-that-matter/"
              target="_blank"
              >Cambridge University Press,</a
            >
            EMBO Press, Oxford University Press)
          </td>
        </tr>
        <tr>
          <td>
            <span id="activity_4" class="activity">
              <b
                >3. Register and improve publishers’ data policies to mandate
                deposition of COVID-19 data</b
              >
            </span>
          </td>
          <td>
            FAIRsharing works within the
            <a
              href="https://oaspa.org/covid-19-publishers-open-letter-of-intent-rapid-review/"
              target="_blank"
              >COVID-19 Rapid Review Initiative</a
            >(C19RRI) to ensure the policies of the participating publishers
            were publicly
            <a href="https://fairsharing.org/3494" target="_blank"
              >registered</a
            >
            and mandated Data Availability Statements (DAS):
            <a
              href="https://oaspa.org/guest-post-covid-19-rapid-review-initiative-an-update-to-our-statement-of-intent/"
              target="_blank"
              >interim report.</a
            >
          </td>
          <td>
            <a
              href="https://oaspa.org/covid-19-publishers-open-letter-of-intent-rapid-review/"
              target="_blank"
              >C19RRI’</a
            >s publishers and scholarly communications organisations
          </td>
        </tr>
        <tr>
          <td class="extra-header-row" colspan="3">
            BUILD - focussing on the technology needed to enable FAIR
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            <span id="activity_5" class="activity">
              <b>4. Define and register FAIR maturity indicators and metrics</b>
            </span>
          </td>
          <td>
            Through a collaboration with
            <a href="https://www.go-fair.org" target="_blank">GO-FAIR</a>,
            FAIRsharing contributed to a prototype set of universal
            machine-actionable measurable metrics, registered in the FAIRsharing
            registry of standards:
            <a href="https://doi.org/10.1038/sdata.2018.118" target="_blank"
              >publication.</a
            >
          </td>
          <td>
            <a
              href="https://www.go-fair.org/implementation-networks/overview/fair-strepo/"
              target="_blank"
              >GO-FAIR StRePo</a
            >
          </td>
        </tr>
        <tr>
          <td>
            Through a participation in
            <a href="https://www.rd-alliance.org/" target="_blank">RDA</a> and
            <a href="https://www.eosc.eu" target="_blank">EOSC</a> groups,
            FAIRsharing works with the community to improve the definition and
            the implementation of FAIR maturity indicators and methodologies.
          </td>
          <td>
            <a href="https://www.eosc.eu/metadata-data-quality" target="_blank"
              >EOSC FAIR Metrics and Data Quality Task Force;</a
            >
            <a
              href="https://www.rd-alliance.org/groups/fair-data-maturity-model-wg"
              target="_blank"
            >
              RDA FAIR Maturity Model WG;</a
            >
            <a
              href="https://www.rd-alliance.org/group/biosharing-registry-connecting-data-policies-standards-databases-life-sciences.html"
              target="_blank"
              >RDA FAIRsharing WG.</a
            >
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            <span id="activity_6" class="activity">
              <b>5. Power FAIR assessment and evaluation tools</b>
            </span>
          </td>
          <td>
            FAIRsharing content powers
            <a href="https://fairshake.cloud/" target="_blank">FAIRshake</a>,
            software to assess the FAIRness of bioinformatics tools, analyses,
            and biological datasets against a variety of different metrics:
            <a href="https://doi.org/10.1016/j.cels.2019.09.011" target="_blank"
              >publication.</a
            >
          </td>
          <td>
            <a href="https://www.nih-cfde.org/" target="_blank"
              >USA NIH Commons Fund Data Ecosystem.</a
            >
          </td>
        </tr>
        <tr>
          <td>
            FAIRsharing content powers the
            <a
              href="https://fairsharing.github.io/FAIR-Evaluator-FrontEnd/#!/"
              target="_blank"
              >FAIR Evaluator</a
            >, software to register and execute tests of compliance with the
            published FAIR Metrics:
            <a href="https://doi.org/10.1038/s41597-019-0184-5" target="_blank"
              >publication.</a
            >
          </td>
          <td>
            <a
              href="https://www.go-fair.org/implementation-networks/overview/fair-strepo/"
              target="_blank"
              >GO-FAIR StRePo IN</a
            >
          </td>
        </tr>

        <tr>
          <td>
            <span id="activity_7" class="activity">
              <b
                >6. Contribute to research and knowledge graphs, and data
                discovery</b
              >
            </span>
          </td>
          <td>
            FAIRsharing works with OpenAIRE to interconnect its content with
            other information in the
            <a href="https://www.openaire.eu/" target="_blank">OpenAIRE</a>
            Research Graphs, providing greater knowledge to researchers and
            other stakeholders, and contributing to data discovery.
          </td>
          <td>
            <a
              href="https://www.openaire.eu/enriching-science-fairsharing-and-openaire-amke-sign-a-memorandum-of-understanding"
              target="_blank"
              ><b>Agreement</b> between FAIRsharing team and OpenAIRE
              collaboration;</a
            >
            <a href="https://by-covid.org/" target="_blank">
              EU Horizon Europe BY-COVID,
            </a>
            and
            <a
              href="https://www.oerc.ox.ac.uk/news/by-covid-project-launched-to-address-pandemic-preparedness/"
              target="_blank"
            >
              news item.
            </a>
          </td>
        </tr>

        <tr>
          <td rowspan="2">
            <span id="activity_8" class="activity">
              <b
                >7. Power tools for data stewardship and data management
                plans</b
              >
            </span>
          </td>
          <td>
            FAIRsharing content powers the
            <a href="https://ds-wizard.org/" target="_blank"
              >Data Stewardship Wizard (DSW)</a
            >, software to create, plan, collaborate, and bring your data
            management plans to life.
          </td>
          <td>
            <a
              href="https://docs.google.com/document/d/1IDbtueAI6-uD7egRfM0hb0pRedSavtc95-fT3A9UB-g/edit?usp=sharing"
              target="_blank"
            >
              <b>Agreement</b> between FAIRsharing and DSW.
            </a>
          </td>
        </tr>
        <tr>
          <td>
            FAIRsharing content powers the
            <a href="https://dmponline.dcc.ac.uk/" target="_blank">DMPonline</a
            >, software to create, review, and share data management plans.
          </td>
          <td>
            <a
              href="https://www.dcc.ac.uk/news/collaboration-between-dmponline-and-fairsharing"
              target="_blank"
            >
              <b>Agreement</b> between FAIRsharing and DMPonline.
            </a>
          </td>
        </tr>

        <tr>
          <td class="extra-header-row" colspan="3">
            TRAIN - focussing on FAIR awareness and skills development
          </td>
        </tr>
        <tr>
          <td>
            <span id="activity_9" class="activity">
              <b>8. Define FAIR competencies, skills, and terminologies</b>
            </span>
          </td>
          <td>
            Through a collaboration with
            <a href="https://codata.org/" target="_blank">CODATA</a>,
            <a href="https://elixir-europe.org/" target="_blank">ELIXIR</a> and
            others, FAIRsharing works to contribute to
            <a href="https://terms4fairskills.github.io/" target="_blank"
              >terms4FAIRskills</a
            >, a terminology to describe the competencies associated with making
            data FAIR.
          </td>
          <td>
            <a
              href="https://www.go-fair.org/implementation-networks/overview/"
              target="_blank"
              >GO-FAIR Training;
            </a>
            <a
              href="https://www.go-fair.org/implementation-networks/overview/fair-strepo/"
              target="_blank"
              >GO-FAIR StRePo IN;
            </a>
            <a href="http://www.codata.org/" target="_blank">CODATA, </a>
            <a href="https://www.fairsfair.eu/" target="_blank">FAIRsFAIR; </a>
            <a href="https://twitter.com/EoscLife" target="_blank"
              >EU INFRA EOSC-Life</a
            >
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            <span id="activity_10" class="activity">
              <b
                >9. Build guidance and training material on standards, databases
                and policies</b
              >
            </span>
          </td>
          <td>
            Through a participation in the
            <a href="https://www.ukrn.org/" target="_blank"
              >UK Reproducibility Network (UKRN)</a
            >
            FAIRsharing focuses on reproducibility through the lens of the FAIR
            into this national peer-led Network, with local (e.g. Reproducible
            Research Oxford, RROx) and international chapters.
          </td>
          <td>
            <a
              href="https://www.ukrn.org/2021/09/15/major-funding-boost-for-uks-open-research-agenda/"
              target="_blank"
              >UKRN</a
            >
            and <a href="https://ox.ukrn.org/" target="_blank">RROx;</a>
            <a
              href="https://www.oerc.ox.ac.uk/news/uk-reproducibility-network-including-oxford-data-readiness-group-awarded-major-national-funding/"
              target="_blank"
              >news item.</a
            >
          </td>
        </tr>
        <tr>
          <td>
            Through a participation in the
            <a
              href="https://elixiruknode.org/fair-data-stewardship-training-project/"
              target="_blank"
              >FAIR Data Stewardship Training Project</a
            >
            FAIRsharing contributes towards capacity building and the
            professionalisation of data stewardship in UK universities and
            research institutes, into this national
            <a href="https://elixiruknode.org/" target="_blank">ELIXIR-UK</a>
            led project.
          </td>
          <td>
            <a
              href="https://elixiruknode.org/fair-data-stewardship-training-project/"
              target="_blank"
              >News item.</a
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ActivitiesStaticTable",
};
</script>

<style lang="scss" scoped>
a {
  &:hover,
  &:focus {
    text-decoration: underline !important;
    outline: 0;
  }
}
.communities-table {
  border: 1px solid #ecf0f1;
  border-collapse: collapse;
  min-width: 800px;
}

.table-scroller {
  overflow-x: auto;
  overflow-y: hidden;
}

table td {
  border: 1px solid #ecf0f1;
  border-collapse: collapse;
  vertical-align: center;
  background-image: none !important;
  text-align: left;
  padding: 20px;
}

.extra-header-row {
  background-color: #e1f9fe;
  vertical-align: center;
  text-align: center !important;
  border-left: none;
}

.activity {
  color: #27aae1;
}
</style>
